import { IconButton, Paper } from '@material-ui/core'
import {
  Close,
  CreateNewFolder,
  GetApp,
  HourglassEmpty,
  InsertDriveFile,
} from '@material-ui/icons'
import axios from 'axios'
import { useState } from 'react'
import Dropzone from 'react-dropzone'
import { useDispatch, useSelector } from 'react-redux'
import { downloadFile } from '../../actions/fileActions'
import customCircleCheck from '../../assets/img/icons/ic-check-circle.png'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import Message from '../Message/Message'
import OverflowTooltip from '../Tooltip/OverflowTooltip'

const SingleFileInput = ({
  file,
  setFile,
  contentTop,
  contentBottom,
  hideStatus,
  project,
}) => {
  const dispatch = useDispatch()
  const [error, setError] = useState('')

  const updatedAt = useDateFormatter(file.updatedAt)

  const { userInfo } = useSelector((state) => state.userLogin)

  const handleDrop = async (item) => {
    setError('')

    if (item[0].type !== 'application/pdf') {
      setError('Please upload a PDF document.')
    } else {
      const formData = new FormData()
      formData.append('file', item[0])

      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.post('/api/file', formData, config)

        setFile(data)
      } catch (error) {
        console.error(error)
        setError(error)
      }
    }
  }

  const handleDownloadClick = () => {
    dispatch(downloadFile(file))
  }

  return Object.keys(file).length === 0 ? (
    <div className={`p-b-16 p-t-16 ${error ? 'error' : ''}`}>
      <Dropzone onDrop={handleDrop} multiple={false}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div
            {...getRootProps({
              className: `dropzone ${isDragActive ? 'hovering' : ''}`,
            })}
          >
            <div className="dropzone-outer">
              <div className="dropzone-inner">
                <input {...getInputProps()} />
                <div className="flex align-center justify-center">
                  <CreateNewFolder />

                  <p className="m-b-0 m-l-5">{contentTop}</p>
                </div>
                <p className="m-b-0 m-l-5">{contentBottom}</p>
              </div>
            </div>
          </div>
        )}
      </Dropzone>
      {error !== '' && <Message variant="danger">{error}</Message>}
    </div>
  ) : (
    <div style={{ maxWidth: '100%', display: 'block' }}>
      <div className={`m-t-24 ${hideStatus ? 'm-b-16' : 'm-b-50'}`}>
        <div className="flex space-between m-b-10 align-center">
          <div className="gray-text fs14 ">{updatedAt}</div>
          <div className="align-center flex flex-end gray-text">
            {!hideStatus &&
            project &&
            project.acceptanceCriteria &&
            project.acceptanceCriteria.length > 0 &&
            project.acceptanceCriteria[project.acceptanceCriteria.length - 1]
              .isSigned ? (
              <div className="signed text-right">
                <img
                  src={customCircleCheck}
                  alt="Circle Check"
                  style={{ width: 14 }}
                />{' '}
                Signed
              </div>
            ) : (
              <>
                <HourglassEmpty style={{ width: 14 }} />
                Pending signature
              </>
            )}
          </div>
        </div>

        <Paper
          className="m-t-5 p-t-5 p-b-5 p-r-5 p-l-10"
          style={{ borderRadius: 0, display: 'block' }}
        >
          <div className="flex space-between fs12 align-center">
            <div
              className="primary flex align-center"
              style={{ width: '100%', maxWidth: 'calc(100% - 48px)' }}
            >
              <InsertDriveFile className="m-r-5" style={{ fontSize: 12 }} />
              <OverflowTooltip title={file.name} />
            </div>

            <div className="text-right flex">
              <IconButton className="small" onClick={handleDownloadClick}>
                <GetApp style={{ color: 'black' }} />
              </IconButton>
              <IconButton className="small" onClick={() => setFile('')}>
                <Close style={{ color: 'black' }} />
              </IconButton>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  )
}

export default SingleFileInput
